import { init } from "../init";
import { SignupPage } from "../pages/try/cloud/signup/signup-page";
init(SignupPage);
